"use strict";

define('model/base',['datakit/model', 'backbone-validation', 'rs/errors', '../collection/base', 'backbone.radio'], function (Model, Validation, RSError, BaseCollection, Radio) {
  var channel = Radio.channel('session');
  _.extend(Validation.messages, {
    maxLength: 'This field cannot have a length greater than {1}.',
    minLength: 'This field must be a minimum length of {1}.',
    naturalNumber: '{0} must be a non-negative integer'
  });
  _.extend(Validation.patterns, {
    naturalNumber: '^[1-9]\d*$'
  });
  function findMatchingField(fieldId) {
    var keys = this.keys(),
      field = String(fieldId).toLowerCase();
    return _.find(keys, function (key) {
      if (key.toLowerCase() === field) {
        return true;
      }
    });
  }
  ;
  function parseValidation(validation) {
    var invalidAttrs = {},
      field = null;
    _.each(validation, function (v) {
      field = findMatchingField.call(this, v.fieldId) || v.fieldId;
      invalidAttrs[field] = v.message;
    }, this);
    this.trigger('validated', false, this, invalidAttrs);
  }
  ;
  function parseResponse(resp) {
    if (resp.valid === false) {
      var sessionErrorMsg = String(resp.error);
      if (sessionErrorMsg === 'Access Denied Must Log In First' || sessionErrorMsg.indexOf('Invalid CSRF') > -1) {
        channel.trigger('fetch:heartbeat');
        throw new RSError.IgnoredError();
      }
      if (resp.validation) {
        this.parseValidation(resp.validation);
        throw new RSError.IgnoredError();
      } else if (resp.error) {
        if (resp.error.detail && resp.error.detail['Traceable Error Code']) {
          throw new RSError.APIError(resp);
        } else {
          throw new Error(resp.error.message || resp.error);
        }
      }
    }
    return resp.data;
  }
  ;
  var Base = Model.extend({
    initialize: function initialize() {
      this.labels = {};
      Model.prototype.initialize.apply(this, arguments);
    },
    ajaxTimeout: 300000,
    parse: parseResponse,
    parseValidation: parseValidation,
    collectionParse: parseResponse,
    validate: Validation.mixin.validate,
    sync: function sync(method, model, options) {
      options = options || {};
      options.timeout = this.ajaxTimeout;
      return Model.prototype.sync.apply(this, arguments);
    }
  }, {
    Collection: BaseCollection,
    createCollection: function createCollection(urlPath, options) {
      if (_.isObject(urlPath)) {
        options = urlPath;
        urlPath = null;
      }
      return Model.createCollection.call(this, urlPath, _.extend({
        model: this,
        url: urlPath,
        parseHandler: this.prototype.collectionParse
      }, options));
    }
  });
  return Base;
});

